import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';
interface IntroSectionProps {
  language: Language;
}
export function IntroSection({
  language
}: IntroSectionProps) {
  const isPashto = language === 'pashto';
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 24
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-60px' as const
    },
    transition: {
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  const fadeInDelay = (delay: number) => ({
    initial: {
      opacity: 0,
      y: 24
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-60px' as const
    },
    transition: {
      duration: 0.7,
      delay,
      ease: [0.16, 1, 0.3, 1]
    }
  });
  return <section className="py-10 md:py-14 px-6 bg-white" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        {/* Two-column layout */}
        <div className="grid grid-cols-1 gap-10 md:gap-12 items-start mb-12 md:mb-16" data-id="element-157">
          {/* About heading + Paragraph */}
          <motion.div {...fadeIn} className="text-start max-w-3xl" data-id="element-158">
            <h2 className={`text-3xl md:text-4xl font-bold text-pasoon-dark mb-2 inline-block relative ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-159">
              {isPashto ? 'د پاڅون په اړه' : 'About Pasoon'}
            </h2>
            {/* Accent line */}
            <div className="w-16 h-1 bg-pasoon-red rounded-full mb-6" data-id="element-160"></div>

            <p className={`text-gray-600 text-base md:text-lg ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-161">
              {isPashto ? 'پاڅون د پښتو ژبې، ادب او زده‌کړې ته په نړیواله کچه وده ورکولو ته وقف دی. د ۲۰۰۵ راهیسې مو بې وقفې خپرونه کړې — او یو له خورا معتبرو پښتو ادبي مجلو څخه شوي یو.' : 'Pasoon is dedicated to promoting Pashto language, literature, and education worldwide. Since 2005, we have published without interruption, becoming one of the most respected Pashto literary magazines in existence.'}
            </p>
          </motion.div>
        </div>

        {/* Bold statement + Supporting paragraph — unified section */}
        <motion.div {...fadeInDelay(0.2)} className="max-w-5xl mx-auto relative" data-id="element-162">
          {/* Vertical accent bar */}
          <div className={`absolute top-0 bottom-0 w-1 bg-pasoon-red rounded-full ${isPashto ? 'right-0 md:right-auto md:left-0' : 'left-0'}`} data-id="element-163"></div>
          <div className={`${isPashto ? 'pr-6 md:pr-0 md:pl-8' : 'pl-6 md:pl-8'}`} data-id="element-164">
            <p className={`text-2xl md:text-3xl lg:text-4xl font-bold text-pasoon-dark mb-6 ${isPashto ? 'font-pashto leading-loose' : 'font-serif leading-snug'}`} data-id="element-165">
              {isPashto ? 'ملیونونه پښتو وایي. ' : 'Millions speak Pashto. '}
              <span className="text-pasoon-red" data-id="element-166">
                {isPashto ? 'ډېری یې لا هم لیکل او لوستل نه شي کولای.' : 'Too many cannot read or write it.'}
              </span>
            </p>

            <p className={`text-gray-600 text-lg md:text-xl ${isPashto ? 'font-pashto leading-[2.2]' : 'leading-relaxed'}`} data-id="element-167">
              {isPashto ? 'ژبه یوازې په ژبه نه ژوندي پاتې کېږي، بلکې په پاڼه باندې هم. پاڅون دا تشه ډکوي — ترڅو هر پښتون چې خپله مورنۍ ژبه وایي، وکولای شي چې لیکل شوې یې وویني، شاعري یې ولولي، او کیسې یې خپلو اولادونو ته ورسوي. دا یوازې مجله نه ده. دا د یوې تمدن غږ ژوندی ساتلو غورځنګ دی.' : "A language lives not just on the tongue, but on the page. Pasoon exists to close that gap — to ensure that every Pashtun who speaks their mother language can also see it written, read its poetry, and pass its stories to their children. This is not just a magazine. It is a movement to keep a civilisation's voice alive."}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}